<template>
  <ul class="paginate">
    <li class="paginate__item paginate__previous" @click="onPreviousPage">&lt;</li>

    <li
      v-for="page in computedPages"
      :key="page"
      class="paginate__item"
      :class="{ 'paginate__item--active': current == page }"
      @click="onChangePage(page)"
    >
      {{ page }}
    </li>

    <li class="paginate__item paginate__next" @click="onNextPage">&gt;</li>
  </ul>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  pages: Number,
  current: Number,
  maxPages: { type: Number, default: 7 }
})

const emit = defineEmits(['change-page'])

const computedPages = computed(() => {
  if (props.maxPages >= props.pages) {
    const pages = []
    for (let i = 1; i <= props.pages; i++) pages.push(i)
    return pages
  }

  let firstPageNumber = props.current - Math.ceil(props.maxPages / 2) + 1
  let lastPageNumber = props.current + Math.floor(props.maxPages / 2)

  if (firstPageNumber <= 0) { firstPageNumber = 1; lastPageNumber = props.maxPages}
  if (lastPageNumber > props.pages) { firstPageNumber = props.pages - props.maxPages + 1; lastPageNumber = props.pages }

  const pages = []
  for (let i = firstPageNumber; i <= lastPageNumber; i++) pages.push(i)
  return pages
})

const onPreviousPage = () => {
  if (props.current - 1 < 1) return
  emit('change-page', props.current - 1)
}

const onChangePage = (page) => {
  emit('change-page', page)
}

const onNextPage = () => {
  if (props.current + 1 > props.pages) return
  emit('change-page', props.current + 1)
}
</script>
